// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b8bbcc2","453":"8dd7f079","732":"e43f152f"}[chunkId] + ".chunk.js";
};